export const FETCH_COLLECTION_PDFS_REQUEST = 'FETCH_COLLECTION_PDFS_REQUEST';
export const FETCH_COLLECTION_PDFS_SUCCESS = 'FETCH_COLLECTION_PDFS_SUCCESS';
export const FETCH_COLLECTION_PDFS_FAILURE = 'FETCH_COLLECTION_PDFS_FAILURE';

export function fetchCollectionPdfsRequest(payload) {
    return {type: FETCH_COLLECTION_PDFS_REQUEST, payload: payload};
}

export function fetchCollectionPdfsSuccess(payload) {
    return {type: FETCH_COLLECTION_PDFS_SUCCESS, payload: payload};
}

export function fetchCollectionPdfsFailure(payload) {
    return {type: FETCH_COLLECTION_PDFS_FAILURE, payload: payload};
}



// WEBPACK FOOTER //
// ./src/_actions/pdf.links.actions.js